<template>
  <v-container>
    <v-simple-table>
      <thead>
        <tr>
          <th style="text-align:center;font-size:x-large">
            {{ currentWord }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in tabooWords" :key="index">
          <td style="text-align:center;font-size:large">{{ item }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>

<script>

export default {
  name: "Card",
  props: {
    gameId: String,
    currentWord: String,
    tabooWords: Array
  },
  created() {
  },
  data() {
    return {
    };
  },
};
</script>
